// 债权类型：对象常量、下拉选项与标签函数（统一复用）
export const DebtTypeOptions = [
  { code: 'GUARANTEE_DEBT', label: '担保债权' },
  { code: 'CONTRACT_ARREARS', label: '合同欠款' },
  { code: 'EFFECTIVE_JUDGMENT', label: '生效判决' },
  { code: 'LOAN_DEBT', label: '借贷债权' },
  { code: 'TORT_DEBT', label: '侵权之债' },
  { code: 'OTHER_DEBT', label: '其他债权' },
];
export const DebtType = {
  GUARANTEE_DEBT: 'GUARANTEE_DEBT',
  CONTRACT_ARREARS: 'CONTRACT_ARREARS',
  EFFECTIVE_JUDGMENT: 'EFFECTIVE_JUDGMENT',
  LOAN_DEBT: 'LOAN_DEBT',
  TORT_DEBT: 'TORT_DEBT',
  OTHER_DEBT: 'OTHER_DEBT',
};
export const labelOfDebtType = (code) => {
  const found = DebtTypeOptions.find(o => String(o.code) === String(code));
  return found ? found.label : String(code || '');
};

// 债权处置方式：对象常量与下拉选项
export const DisposalMethod = {
  RETAIN: 'RETAIN',
  OUTSOURCED_COLLECTION: 'OUTSOURCED_COLLECTION',
  LOW_PRICE_TRANSFER: 'LOW_PRICE_TRANSFER',
};
export const DisposalMethodOptions = [
  { code: DisposalMethod.RETAIN, label: '保留' },
  { code: DisposalMethod.OUTSOURCED_COLLECTION, label: '委外催收' },
  { code: DisposalMethod.LOW_PRICE_TRANSFER, label: '低价转让' },
];

export const labelOfDisposalMethod = (code) => {
  const found = DisposalMethodOptions.find(o => String(o.code) === String(code));
  return found ? found.label : String(code || '');
};

// 低价转让方式：对象常量与下拉选项
export const LowPriceOption = {
  PRICING: 'PRICING',
  DISCOUNT: 'DISCOUNT',
  NEGOTIATED: 'NEGOTIATED',
};
export const LowPriceOptionOptions = [
  { code: LowPriceOption.PRICING, label: '定价' },
  { code: LowPriceOption.DISCOUNT, label: '折扣' },
  { code: LowPriceOption.NEGOTIATED, label: '另行商议' },
];

// 低价转让方式：标签函数
export const labelOfLowPriceOption = (code) => {
  const found = LowPriceOptionOptions.find(o => String(o.code) === String(code));
  return found ? found.label : String(code || '');
};

export const formatTransferConditionText = (record, options = {}) => {
  if (!record) return '';

  const {
    formatAmount,
    fieldMap,
  } = options || {};

  const effectiveFieldMap = fieldMap || (record.disposal_method != null || record.low_price_option != null
    ? {
      disposalMethod: 'disposal_method',
      lowPriceOption: 'low_price_option',
      transferPricingAmount: 'transfer_pricing_amount',
      transferDiscountRate: 'transfer_discount_rate',
    }
    : {
      disposalMethod: 'disposalMethod',
      lowPriceOption: 'lowPriceOption',
      transferPricingAmount: 'transferPricingAmount',
      transferDiscountRate: 'transferDiscountRate',
    });

  const disposalMethod = record?.[effectiveFieldMap.disposalMethod];
  if (String(disposalMethod) !== 'LOW_PRICE_TRANSFER') return '';

  const lowPriceOption = record?.[effectiveFieldMap.lowPriceOption];
  const option = LowPriceOptionOptions.find(o => String(o.code) === String(lowPriceOption));

  if (String(lowPriceOption) === 'PRICING') {
    const amount = record?.[effectiveFieldMap.transferPricingAmount];
    if (amount === undefined || amount === null || amount === '') return option?.label || '';
    return `一口价：${formatAmount ? formatAmount(amount) : String(amount)}`;
  }

  if (String(lowPriceOption) === 'DISCOUNT') {
    const rate = record?.[effectiveFieldMap.transferDiscountRate];
    if (rate === undefined || rate === null || rate === '') return option?.label || '';
    return `折扣：${rate}%`;
  }

  return option?.label || '';
};

// 债权人类型：对象常量与下拉选项
export const CreditorType = {
  PERSONAL: 'P',
  ENTERPRISE: 'E',
};
export const CreditorTypeOptions = [
  { value: CreditorType.PERSONAL, label: '个人' },
  { value: CreditorType.ENTERPRISE, label: '企业' },
];

// 未履行原因：下拉选项
export const NonPerformanceReasonOptions = [
  { code: 'INSUFFICIENT_ABILITY', label: '履行能力不足' },
  { code: 'DISHONEST', label: '不讲诚信' },
  { code: 'POOR_URGING', label: '我方催告不力' },
  { code: 'SELF_DEFENSE', label: '自以为可抗辩' },
  { code: 'OTHER', label: '其他' },
];

// 证据类型：下拉选项
export const EvidenceTypeOptions = [
  { code: 'CONTRACT_UNSUED', label: '未诉合同' },
  { code: 'IOU', label: '借据' },
  { code: 'RECEIPT', label: '收据' },
  { code: 'INVOICE', label: '发票' },
  { code: 'TRANSFER_VOUCHER', label: '转账凭证' },
  { code: 'DEBT_NOTE', label: '欠条' },
  { code: 'LETTER_OF_GUARANTEE', label: '保证函' },
  { code: 'ACCOUNT_STATEMENT', label: '往来账目' },
  { code: 'CHAT_LOG', label: '聊天记录' },
  { code: 'CALL_RECORDING', label: '通话录音' },
  { code: 'EMAIL_CORRESPONDENCE', label: '邮件往来' },
  { code: 'INFRINGEMENT_PHOTO_FRONT', label: '侵权照片正面' },
  { code: 'INFRINGEMENT_PHOTO_BACK', label: '侵权照片反面' },
  { code: 'CONTRACT', label: '合同' },
  { code: 'DEMAND_LETTER', label: '催告函' },
  { code: 'AUTHORIZATION_LETTER', label: '授权书' },
  { code: 'OTHER', label: '其他' },
];

// 债权状态：标签映射与对象常量
export const DebtStatusLabels = {
  DRAFT: '草稿',
  PENDING: '待审核',
  PUBLISHED: '已发布',
  REVOKED: '已撤销',
};

// 审核状态：标签映射与对象常量
export const AuditStatusLabels = {
  NONE: '未审核',
  APPROVED: '审核通过',
  REJECTED: '审核驳回',
};

export const labelOfDebtStatus = (code) => DebtStatusLabels[code] || String(code || '');
export const labelOfAuditStatus = (code) => AuditStatusLabels[code] || String(code || '');

// 催收状态：标签映射
export const CollectionStatusLabels = {
  NOT_COLLECTED: '未催收',
  IN_COLLECTION: '催收中',
  PAUSED: '暂停催收',
  CLOSED: '已结案',
};
export const labelOfCollectionStatus = (code) => CollectionStatusLabels[code] || String(code || '');

// 状态对象常量
export const DebtStatus = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  PUBLISHED: 'PUBLISHED',
  REVOKED: 'REVOKED',
};
export const AuditStatus = {
  NONE: 'NONE',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

// 审核状态下拉选项（统一复用）
export const AuditStatusOptions = [
  { value: AuditStatus.NONE, label: AuditStatusLabels.NONE },
  { value: AuditStatus.APPROVED, label: AuditStatusLabels.APPROVED },
  { value: AuditStatus.REJECTED, label: AuditStatusLabels.REJECTED },
];

// 下拉选项辅助转换：按统一 `{ value, label }` 结构输出
export const toSelectOptions = (options) => options.map(opt => ({ value: opt.value ?? opt.code, label: opt.label }));

// 跟进日志类型：下拉选项与标签函数
export const FollowupLogTypeOptions = [
  { value: 'NOTICE_RESULT', label: '催告结果' },
  { value: 'CONTACT', label: '日常联系' },
  { value: 'PROMISE_TO_PAY', label: '承诺还款' },
  { value: 'PAYMENT_CONFIRM', label: '回款确认' },
  { value: 'EVIDENCE_UPDATE', label: '证据更新' },
  { value: 'SERVICE', label: '法律服务进展' },
  { value: 'RISK_EVENT', label: '风险事件' },
  { value: 'STATUS_CHANGE', label: '状态变更' },
  { value: 'OTHER', label: '其他' },
];

export const labelOfFollowupType = (code) => {
  const found = FollowupLogTypeOptions.find(o => String(o.value) === String(code) || String(o.code) === String(code));
  return found ? found.label : String(code || '');
};

// 催告发送方式：下拉选项与标签函数
export const NoticeSendMethodOptions = [
  { value: 'SMS', label: '短信' },
  { value: 'EMAIL', label: '邮件' },
  { value: 'WECHAT', label: '微信转发' },
];

export const labelOfNoticeSendMethod = (code) => {
  const found = NoticeSendMethodOptions.find(o => String(o.value) === String(code));
  return found ? found.label : String(code || '');
};

// 债权广场意向类型：下拉选项
export const IntentTypeOptions = [
  { value: 'INVEST', label: '我要投资' },
  { value: 'AGENCY_COLLECTION', label: '代理催收' },
];
